import { ModelYearOption } from '../types';

export const createYearOptionObject = (filterTagState: boolean, usedVehicleSelected: boolean) => {
  const currentDate = new Date();

  const currentYr = currentDate.getFullYear();
  const nextYr = currentYr + 1;
  const currentMonth = currentDate.getMonth();

  let year = 2009;

  if (!usedVehicleSelected) year = currentYr - 3;

  const yearOptions: ModelYearOption = {};
  while (year <= nextYr) {
    if (year === nextYr && currentMonth < 6) break;
    yearOptions[year] = {
      label: `${year}`,
      ariaLabel: `${year}`,
      value: year,
      isFilterTagNotRemovable: filterTagState,
    };

    // eslint-disable-next-line
    year++;
  }
  return yearOptions;
};
